import { render } from "./EnrolmentRowSkeleton.vue?vue&type=template&id=baee76f2"
import script from "./EnrolmentRowSkeleton.vue?vue&type=script&lang=ts"
export * from "./EnrolmentRowSkeleton.vue?vue&type=script&lang=ts"
script.render = render

export default script